import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as homepageSlice from "../../../../redux/slices/homepageSlice";
import * as locationSlice from "../../../../redux/slices/locationSlice";
import * as faqChatSlice from "../../../../redux/slices/faqChatSlice";
import * as reviewSlice from "../../../../redux/slices/reviewSlice";
import { toast } from "react-toastify";
import { imageBaseUrl } from "../../../../helper";
import DataTable from "react-data-table-component"; // Import DataTable
import DeleteModal from "../../components/DeleteModal";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";
import moment from "moment";

const CustomizeReview = () => {
  const [showEditTempleModal, setShowEditTempleModal] = useState(false);
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [locationId, setLocationId] = useState();
  const { locationData } = useSelector((state) => state.locationSlice);
  const {customReview, loading } = useSelector(
    (state) => state.reviewSlice
  );
  const [sortNumber, setSortNumber] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const [previewImage, setPreviewImage] = useState();

  // Modal state for adding temple
  const [showAddTempleModal, setShowAddTempleModal] = useState(false);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
    dispatch(reviewSlice.getCustomReview());
  }, [dispatch]);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
  }, [showEditTempleModal]);

  // Handle delete
  const handleDelete = async (locationId) => {
    await dispatch(faqChatSlice.destroyTopic(locationId));
    dispatch(faqChatSlice.getTopics());
    setDeleteModal(false);
  };


  // DataTable columns definition
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => moment(row.created_at).format('DD/MM/YYYY HH:mm'),
      sortable: true,
    },
    {
      name: "Image",
      selector: (row) => <img src={`${imageBaseUrl}User/${row?.user?.profile_image}`} style={{ width: "50px", height: "50px" }} />,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row?.user?.first_name + " " + row?.user?.last_name || "-",
      sortable: true,
    },
    {
      name: "Number",
      selector: (row) => row?.user?.mobile_no || "-",
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: "Feedback",
      selector: (row) => row?.review || "-",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) =>
        row?.status == "1"
          ? "Pending"
          : row?.status == "2"
          ? "Approved"
          : "Rejected",
      sortable: true,
    },
    {
      name: "Rating",
      selector: (row) => row?.rating || "-",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          {/* <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div> */}
          <div
            className="edit ml-1"
            onClick={(e) => {
              handleOnEditClick(row.id);
              setShowAddTempleModal(true);
              setIsEdit(true);
            }}
          >
            <NotePencil size={18} />
          </div>
        </div>
      ),
    },
  ];

  const handleOnEditClick = (id) => {
    const data = customReview?.find((h) => h?.id === id);
    setLocationId(data?.id);
    setForm({
      ...form,
      rating: data?.rating,
      review: data?.review,
      status: data?.status,
    });
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    await dispatch(reviewSlice.updateCustomReview(locationId, form));
    setSelectedImage(null);
    setPreviewImage(null);
    setShowAddTempleModal(false);
    dispatch(reviewSlice.getCustomReview());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form?.topic) {
      toast("Enter topic name please");
      return;
    }
    // await dispatch(faqChatSlice.storeTopic(form, setForm));
    setShowAddTempleModal(false);
    dispatch(reviewSlice.getCustomReview());
  };
  console.log(customReview, "customReview");
  return (
    <>
      <h5 className="mb-4">Customize Package Reviews</h5>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={(customReview?.length && customReview) || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      {/* Add Banner Modal */}
      <Modal
        show={showAddTempleModal}
        onHide={() => setShowAddTempleModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w" // Optional: To make the modal wider
      >
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Update" : "Add"} Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Rating</Form.Label>
              <Form.Control
                type="text"
                value={form?.rating}
                disabled={true}
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
            <Form.Group controlId="formReview" className="mb-3">
              <Form.Label>Feedback</Form.Label>
              <Form.Control
                as="textarea" // Switches to a textarea
                rows={5} // Adjust rows to display more content by default
                value={form?.review}
                disabled={true} // Keeps the field read-only
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>

            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Change Status</Form.Label>
              <Form.Select
                value={form?.status} // Assuming `form.status` holds the selected status
                onChange={(e) => setForm({ ...form, status: e.target.value })} // Update form state on change
                required // Optional: If you want to make this field mandatory
              >
                <option value="">Select Status</option>{" "}
                {/* Placeholder option */}
                <option value="1">Pending</option>
                <option value="2">Approved</option>
                <option value="3">Reject</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddTempleModal(false)}
          >
            Close
          </Button>

          <Button variant="primary" type="submit" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomizeReview;
